<template>
  <div class="product-template-search">
    <!-- 搜索、重置 -->
    <div class="queryCondition">
        <el-row>
          <el-col :span="22">
            <el-row>
              <el-col class="product-template-search-item">
                <el-input v-model="queries.templateCode" @keyup.enter.native="inquire" :placeholder="$translate('lang.E3202102250023', { defaultText: '模板编码' })"></el-input>
              </el-col>
              <el-col class="product-template-search-item">
                <el-input v-model="queries.templateName" @keyup.enter.native="inquire" :placeholder="$translate('lang.E3202102250024', { defaultText: '模板名称' })"></el-input>
              </el-col>
              <el-col class="product-template-search-item">
                <el-select v-model="queries.status" clearable  >
                  <el-option :label="$translate('lang.E3202102260004', { defaultText: '启用' })" value="Y"></el-option>
                  <el-option :label="$translate('lang.E3202102260003', { defaultText: '停用' })" value="N"></el-option>
                </el-select>
              </el-col>
              <el-col class="product-template-search-item">
                <el-input v-model="queries.createUserName" @keyup.enter.native="inquire" :placeholder="$translate('lang.E3202102250026', { defaultText: '创建人' })"></el-input>
              </el-col>
              <div>
                <el-button type="primary" size="mini" @click="inquire" :loading="queryBlock" icon='el-icon-search'>
                  {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                </el-button>
                <el-button class="sn-search-reset-button" @click="reset" size="mini" >
                  {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                </el-button>
              </div>
            </el-row>
            <el-row class="product-template-search-second-row">
              <el-col class="product-template-search-item">
                <el-date-picker
                    v-model="timeHorizon"
                    class="product-template-search-date-picker"
                    type="datetimerange"
                    align="left"
                    value-format='yyyy-MM-dd HH:mm:ss'
                    :default-time="['00:00:00', '23:59:59']"
                    unlink-panels
                    range-separator="-"
                    :start-placeholder="$translate('lang.E3202101270023', { defaultText: '开始日期' })"
                    :end-placeholder="$translate('lang.E3202101270024', { defaultText: '结束日期' })"
                    size="mini"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
    </div>
  </div>
</template>
<script>
import formatTime from '@/utils/common.js';
export default {
    props: ['queryBlock', 'templateBlock'],
    data() {
        return {
            queries: {
                templateCode: '',
                templateName: '',
                createUserName: '',
                status: 'Y',
                orderBy: 'updateTime',
                orderByType: 'desc'
            },
            timeHorizon: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$translate('lang.E3202101270017', { defaultText: '最近一周' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(6), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270019', { defaultText: '最近一个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(30), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270021', { defaultText: '最近三个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(90), formatTime.initEndDate()]);
                        }
                    }
                ]
            }
        };
    },
    methods: {
        inquire() {
            this.$emit('queries');
        },
        // 重置
        reset() {
            this.timeHorizon = [];
            this.queries = this.$options.data.call(this).queries;
        }
    },
    mounted() {
        this.inquire();
    }
};
</script>
<style lang="less">
.product-template-search{
  margin-bottom: 20px;
  .product-template-search-item{
    width: 190px;
    margin-right: 10px;
    .el-select{
      width: 100%;
    }
  }
  .product-template-search-second-row{
    margin-top: 12px;
  }
  .product-template-search-date-picker{
    width: 100%;
    .el-range__icon {
        display: none;
    }
  }
}
</style>